var _namedview, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _line31, _line32, _line33, _line34, _line35, _line36, _line37, _line38, _line39, _line40, _g, _g2, _g3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDrawerBTemplate = function SvgDrawerBTemplate(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "226.20001mm",
    height: "208.2mm",
    viewBox: "0.5 6 226.20001 208.2",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _namedview || (_namedview = /*#__PURE__*/React.createElement("namedview", {
    bordercolor: "#666666",
    borderopacity: 1,
    "fit-margin-bottom": 5,
    "fit-margin-left": 5,
    "fit-margin-right": 5,
    "fit-margin-top": 5,
    gridtolerance: 10,
    guidetolerance: 10,
    objecttolerance: 10,
    pagecolor: "#ffffff",
    showgrid: "false"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 5.5999999,
    x2: 25.4,
    y1: 12.1,
    y2: 12.1,
    stroke: "#000",
    strokeWidth: 0.2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 28.4,
    x2: 25.4,
    y1: 11.1,
    y2: 12.1,
    stroke: "#000",
    strokeWidth: 0.2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 28.4,
    x2: 86.599998,
    y1: 11.1,
    y2: 11.1,
    stroke: "#000",
    strokeWidth: 0.2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 86.599998,
    x2: 86.599998,
    y1: 11.1,
    y2: 56,
    stroke: "#000",
    strokeWidth: 0.2
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 86.599998,
    x2: 88.599998,
    y1: 56,
    y2: 58.099998,
    stroke: "#000",
    strokeWidth: 0.2
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 90.699997,
    x2: 88.599998,
    y1: 37.099998,
    y2: 58.099998,
    stroke: "#000",
    strokeWidth: 0.2
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 90.699997,
    x2: 115.6,
    y1: 37.099998,
    y2: 37.099998,
    stroke: "#000",
    strokeWidth: 0.2
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 115.6,
    x2: 138.60001,
    y1: 37.099998,
    y2: 58.099998,
    stroke: "#000",
    strokeWidth: 0.2
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 138.60001,
    x2: 138.60001,
    y1: 58.099998,
    y2: 60.099998,
    stroke: "#000",
    strokeWidth: 0.2
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 161.60001,
    x2: 138.60001,
    y1: 37.099998,
    y2: 58.099998,
    stroke: "#000",
    strokeWidth: 0.2
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 161.60001,
    x2: 197.60001,
    y1: 37.099998,
    y2: 37.099998,
    stroke: "#000",
    strokeWidth: 0.2
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 197.60001,
    x2: 201.60001,
    y1: 37.099998,
    y2: 57.099998,
    stroke: "#000",
    strokeWidth: 0.2
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 198.60001,
    x2: 201.60001,
    y1: 60.099998,
    y2: 57.099998,
    stroke: "#000",
    strokeWidth: 0.2
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 198.60001,
    x2: 221.60001,
    y1: 60.099998,
    y2: 63.099998,
    stroke: "#000",
    strokeWidth: 0.2
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 221.60001,
    x2: 221.60001,
    y1: 63.099998,
    y2: 157.09999,
    stroke: "#000",
    strokeWidth: 0.2
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 198.60001,
    x2: 221.60001,
    y1: 160.09999,
    y2: 157.09999,
    stroke: "#000",
    strokeWidth: 0.2
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 198.60001,
    x2: 201.60001,
    y1: 160.09999,
    y2: 163.2,
    stroke: "#000",
    strokeWidth: 0.2
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 197.60001,
    x2: 201.60001,
    y1: 183.09999,
    y2: 163.2,
    stroke: "#000",
    strokeWidth: 0.2
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 161.60001,
    x2: 197.60001,
    y1: 183.09999,
    y2: 183.09999,
    stroke: "#000",
    strokeWidth: 0.2
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    x1: 138.60001,
    x2: 161.60001,
    y1: 162.2,
    y2: 183.09999,
    stroke: "#000",
    strokeWidth: 0.2
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    x1: 138.60001,
    x2: 138.60001,
    y1: 160.09999,
    y2: 162.2,
    stroke: "#000",
    strokeWidth: 0.2
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    x1: 115.6,
    x2: 138.60001,
    y1: 183.09999,
    y2: 162.2,
    stroke: "#000",
    strokeWidth: 0.2
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    x1: 90.699997,
    x2: 115.6,
    y1: 183.09999,
    y2: 183.09999,
    stroke: "#000",
    strokeWidth: 0.2
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    x1: 88.599998,
    x2: 90.699997,
    y1: 162.2,
    y2: 183.09999,
    stroke: "#000",
    strokeWidth: 0.2
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    x1: 86.599998,
    x2: 88.599998,
    y1: 164.2,
    y2: 162.2,
    stroke: "#000",
    strokeWidth: 0.2
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    x1: 86.599998,
    x2: 86.599998,
    y1: 164.2,
    y2: 209.09999,
    stroke: "#000",
    strokeWidth: 0.2
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    x1: 28.4,
    x2: 86.599998,
    y1: 209.09999,
    y2: 209.09999,
    stroke: "#000",
    strokeWidth: 0.2
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    x1: 25.4,
    x2: 28.4,
    y1: 208.09999,
    y2: 209.09999,
    stroke: "#000",
    strokeWidth: 0.2
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    x1: 5.5999999,
    x2: 25.4,
    y1: 208.09999,
    y2: 208.09999,
    stroke: "#000",
    strokeWidth: 0.2
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    x1: 5.5999999,
    x2: 5.5999999,
    y1: 162.09999,
    y2: 208.09999,
    stroke: "#000",
    strokeWidth: 0.2
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    x1: 5.5999999,
    x2: 23.4,
    y1: 162.09999,
    y2: 162.2,
    stroke: "#000",
    strokeWidth: 0.2
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    x1: 28.6,
    x2: 23.4,
    y1: 160.09999,
    y2: 162.2,
    stroke: "#000",
    strokeWidth: 0.2
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    x1: 23.4,
    x2: 28.6,
    y1: 159.09999,
    y2: 160.09999,
    stroke: "#000",
    strokeWidth: 0.2
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    x1: 5.5999999,
    x2: 23.4,
    y1: 159.09999,
    y2: 159.09999,
    stroke: "#000",
    strokeWidth: 0.2
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    x1: 5.5999999,
    x2: 5.5999999,
    y1: 61.099998,
    y2: 159.09999,
    stroke: "#000",
    strokeWidth: 0.2
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    x1: 5.5999999,
    x2: 23.4,
    y1: 61.099998,
    y2: 61.099998,
    stroke: "#000",
    strokeWidth: 0.2
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    x1: 28.4,
    x2: 23.4,
    y1: 60.099998,
    y2: 61.099998,
    stroke: "#000",
    strokeWidth: 0.2
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    x1: 23.4,
    x2: 28.4,
    y1: 58.099998,
    y2: 60.099998,
    stroke: "#000",
    strokeWidth: 0.2
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    x1: 5.5999999,
    x2: 23.4,
    y1: 58.099998,
    y2: 58.099998,
    stroke: "#000",
    strokeWidth: 0.2
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    x1: 5.5999999,
    x2: 5.5999999,
    y1: 12.1,
    y2: 58.099998,
    stroke: "#000",
    strokeWidth: 0.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "width"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 28.163683,
    x2: 28.163683,
    y1: 60.099998,
    y2: 160.09999,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 28.163683,
    x2: 27.163668,
    y1: 60.099998,
    y2: 64.099998,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 28.163683,
    x2: 29.163691,
    y1: 60.099998,
    y2: 64.099998,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 28.163683,
    x2: 27.163668,
    y1: 160.09999,
    y2: 156.09999,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 28.163683,
    x2: 29.163691,
    y1: 160.09999,
    y2: 156.09999,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("text", {
    x: -112.10001,
    y: 33.163754,
    fill: "#000",
    fontSize: "3.5px",
    textAnchor: "middle",
    transform: "rotate(-90)"
  }, "\n            Width\n        "))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "depth",
    display: "inline"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 88.599998,
    x2: 84.599998,
    y1: 60.133377,
    y2: 59.133369,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 88.599998,
    x2: 84.599998,
    y1: 60.133377,
    y2: 61.133377,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 28.6,
    x2: 32.600002,
    y1: 60.133377,
    y2: 59.133369,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 28.6,
    x2: 32.600002,
    y1: 60.133377,
    y2: 61.133377,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 57.071537,
    y: 58.35392,
    fill: "#000",
    strokeWidth: 0.05,
    fontSize: "3.5px",
    textAnchor: "middle"
  }, "\n            Depth\n        "), /*#__PURE__*/React.createElement("line", {
    x1: 28.6,
    x2: 88.599998,
    y1: 60.133377,
    y2: 60.133377,
    stroke: "#000",
    strokeWidth: 0.5
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "height"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 88.599998,
    x2: 138.60001,
    y1: 60.133377,
    y2: 60.133377,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 138.60001,
    x2: 134.60001,
    y1: 60.133377,
    y2: 59.133369,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 138.60001,
    x2: 134.60001,
    y1: 60.133377,
    y2: 61.133377,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 88.599998,
    x2: 92.599998,
    y1: 60.133377,
    y2: 59.133369,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 88.599998,
    x2: 92.599998,
    y1: 60.133377,
    y2: 61.133377,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 113.08623,
    y: 58.35392,
    fill: "#000",
    strokeWidth: 0.05,
    fontSize: "3.5px",
    textAnchor: "middle"
  }, "\n            Height\n        "))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDrawerBTemplate, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/drawer-b-template.8d45a44d.svg";
export { ForwardRef as ReactComponent };